<template>
    <div class="inline-block h-[68px] flex justify-items-center hover:border-b-2 hover:border-[#ec4899] hover:border-solid" 
      @mouseover="changeHoverState(true)" @mouseleave="changeHoverState(false)" @keydown.enter="revertState">
      <a href="#" class="inline-flex items-center justify-between px-2 py-1 hover:text-red-500 font-semibold hover:border-b-1 hover:border-[#ec4899] hover:border-solid transition-all duration-500 rounded-md focus:outline-none focus:text-brand-900 sm:focus:shadow-outline">
        <slot name="menu"></slot>
        <svg fill="currentColor" viewBox="0 0 20 20" class="flex-shrink-0 w-5 h-5 ml-1">
          <path :class="{ 'rotate-180': isVisible }" class="transition duration-300 ease-in-out origin-center transform" fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"></path>
        </svg>
      </a>
      <transition enter-active-class="transition duration-300 ease-out transform" 
        enter-class="-translate-y-3 scale-95 opacity-0" 
        enter-to-class="translate-y-0 scale-100 opacity-100" 
        leave-active-class="transition duration-150 ease-in transform" 
        leave-class="translate-y-0 opacity-100" 
        leave-to-class="-translate-y-3 opacity-0">
        <div v-show="isVisible" class="absolute left-0 right-0 top-[68px] w-full py-6 bg-white z-10 shadow-2xl rounded-b-2xl">
          <slot></slot>
        </div>
      </transition>
    </div>

</template>

<script>
export default {
  data() {
    return {
      isVisible: false,
    }
  },
  methods: {
    changeHoverState(isHovered) {
      this.isVisible = isHovered
      this.$emit('hoverChanged', isHovered);
    },
    revertState() {
      this.isVisible = !this.isVisible;
      this.$emit('hoverChanged', this.isVisible);
    }
  }
}
</script>